















































import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";

import InlineSpinner from "@/lib/components/InlineSpinner.vue";

import BatchInvoice from "../batch-invoice.model";
import FactoryInvoice from "../factory-invoice.model";
import InvoiceRowsMixin from "../invoice-rows.mixin";

@Component({
  components: {
    InlineSpinner,
  },
})
export default class InvoiceSummary extends mixins(InvoiceRowsMixin) {
  @Prop({ default: false })
  public readonly isLoading!: boolean;

  @Prop({ default: false })
  public readonly hasError!: boolean;

  private fAreSampleInvoicesExpanded = false;

  get visibleSampleInvoices(): FactoryInvoice[] {
    if (this.fAreSampleInvoicesExpanded) {
      return this.sampleInvoices;
    }

    return this.sampleInvoices.slice(0, 2);
  }

  get hasHiddenSampleInvoices(): boolean {
    return !this.hasBatchInvoices && this.sampleInvoices.length > 2;
  }

  get moreButtonLabel(): string {
    if (this.fAreSampleInvoicesExpanded) {
      return "Show less";
    }

    return `+${this.sampleInvoices.length - 2} more`;
  }

  public getInvoiceLabel(
    invoice: FactoryInvoice,
    batchInvoice?: BatchInvoice
  ): string {
    const typeName = this.getInvoiceTypeName(invoice, batchInvoice);
    const statusName = this.getInvoiceStatusName(invoice);
    const status = statusName ? ` [${statusName}]` : "";

    return `${typeName} #${invoice.number}${status}`;
  }

  public toggleSampleInvoices(): void {
    this.fAreSampleInvoicesExpanded = !this.fAreSampleInvoicesExpanded;
  }
}
